import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { disableDebugTools } from '@angular/platform-browser';
import { User } from '../../models/user';
import { ScreeningService } from '../../services/screening.service';

@Component({
  selector: 'app-add-address-detail',
  templateUrl: './add-address-detail.component.html',
  styleUrls: ['./add-address-detail.component.css']
})
export class AddAddressDetailComponent implements OnInit {
  headerText: string;
  labelText: string;
  action: string;
  addressData: any;
  addressForm: FormGroup;
  type: string;
  userData = new User();
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<AddAddressDetailComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder,
              private screeningService: ScreeningService) {
    this.headerText = data.headerText;
    this.labelText = data.labelText;
    this.action = data.action;
    this.addressData = data.addressData;
    this.type = data.type;
     }

  ngOnInit() {
    this.userData = JSON.parse(sessionStorage.getItem('user_data'));
    this.initAddressForm();
  }
  initAddressForm() {
    this.addressForm = this.formBuilder.group({
      cityName: new FormControl({
        value: this.type === 'cityName' ? this.addressData.cityId : this.addressData.city,
        disabled: this.type === 'locationName' ? true : false
      }),
      districtName: new FormControl({
        value: this.type === 'districtName' ? this.addressData.districtId : this.addressData.district,
        disabled: this.type !== 'districtName' ? true : false
      }),
      cityId: new FormControl(this.type === 'cityName' ? 0 : this.addressData.cityId),
      districtId: new FormControl(this.type === 'districtName' ? 0 : this.addressData.districtId),
      stateName: new FormControl({ value: this.type === 'stateName' ? this.addressData.stateId : this.addressData.state, disabled: true}),
      stateId: new FormControl(this.type === 'stateName' ? 0 : this.addressData.stateId),
      countryName: new FormControl({ value: this.type === 'countryName' ? this.addressData.countryId : this.addressData.country, disabled: true }),
      countryId: new FormControl(this.type === 'countryName' ? 0 : this.addressData.countryId),
      locationId: new FormControl(this.type === 'locationName' ? 0 : this.addressData.locationId ? this.addressData.locationId : 0),
      locationName: new FormControl(this.type === 'locationName' ? this.addressData.locationId : this.addressData.place),
      postalCode: new FormControl(this.addressData.postalCode),
      // createdUserId: new FormControl((this.userData && this.userData.userId > 0) ? this.userData.userId : null),
      //Added by megala by - DAV location Add issue
      createdUserId: new FormControl((this.userData && this.userData.userId > 0) ? this.userData.userId : 1),
    });
  }
  saveAddress() {
    if (this.addressForm.valid) {
      this.dialogRef.close({
        action: 'save',
        data: this.addressForm.getRawValue()
      });
    } else {
      this.addressForm.markAllAsTouched();
    }
  }

}
